import styled from '@emotion/styled/macro';
import { Box } from '../Box';

export const Pagination = styled(Box)();

Pagination.defaultProps = {
  as: 'nav'
};
